function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.7695 88.7696C68.4623 109.077 35.5377 109.077 15.2304 88.7696C-5.07682 68.4623 -5.07681 35.5377 15.2304 15.2304C35.5377 -5.07682 68.4623 -5.07682 88.7695 15.2304C109.077 35.5377 109.077 68.4623 88.7695 88.7696ZM18.9742 77.9547L77.9547 18.9742C61.4713 5.98676 37.5072 7.09585 22.3015 22.3015C7.09584 37.5072 5.98676 61.4713 18.9742 77.9547ZM81.6985 81.6985C66.4928 96.9042 42.5287 98.0132 26.0453 85.0258L85.0258 26.0453C98.0132 42.5287 96.9042 66.4928 81.6985 81.6985Z",
  fill: "#FAF7F8"
});

function SvgFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.19ec853453928eefa1ba6e2a52b74976.svg";
export { ForwardRef as ReactComponent };